export default __webpack_public_path__ + "static/28-726c412b0ccd49c531d70920fabde067.jpg";